// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_np-0";